import { Helmet } from 'react-helmet-async';

export default function CareersPage() {
  const benefits = [
    {
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      title: 'Competitive Salary',
      description: 'Top-of-market compensation with equity'
    },
    {
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
        </svg>
      ),
      title: 'Health & Wellness',
      description: 'Full medical, dental, and vision coverage'
    },
    {
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
        </svg>
      ),
      title: 'Remote First',
      description: 'Work from anywhere with flexible hours'
    },
    {
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z" />
        </svg>
      ),
      title: 'Event Perks',
      description: 'Free tickets to amazing events'
    },
    {
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
        </svg>
      ),
      title: 'Learning Budget',
      description: '$2,000/year for courses and conferences'
    },
    {
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
      ),
      title: 'Unlimited PTO',
      description: 'Take the time you need to recharge'
    }
  ];

  const openings = [
    {
      title: 'Senior Frontend Engineer',
      department: 'Engineering',
      location: 'Remote (US)',
      type: 'Full-time'
    },
    {
      title: 'Backend Engineer',
      department: 'Engineering',
      location: 'Remote (US)',
      type: 'Full-time'
    },
    {
      title: 'Product Designer',
      department: 'Design',
      location: 'Remote (US)',
      type: 'Full-time'
    },
    {
      title: 'Customer Success Manager',
      department: 'Operations',
      location: 'Remote (US)',
      type: 'Full-time'
    }
  ];

  const values = [
    { title: 'Customer Obsessed', desc: 'Every decision starts with "how does this help our users?"' },
    { title: 'Move Fast', desc: 'We ship early, iterate often, and learn from everything.' },
    { title: 'Radical Transparency', desc: 'Open communication builds trust and better products.' },
    { title: 'Own It', desc: 'We take responsibility and see things through.' }
  ];

  return (
    <>
      <Helmet><title>Careers | BESTIX</title></Helmet>
      <div className="min-h-screen bg-gray-50">
        <div className="bg-navy py-20">
          <div className="container mx-auto px-4 text-center">
            <h1 className="font-playfair text-4xl md:text-5xl font-bold !text-white mb-4">Join Our Team</h1>
            <p className="text-xl text-gray-300 max-w-2xl mx-auto">
              Help us build the future of live event ticketing
            </p>
          </div>
        </div>

        <div className="container mx-auto px-4 py-16">
          {/* Mission */}
          <div className="max-w-3xl mx-auto text-center mb-16">
            <h2 className="text-2xl font-semibold text-navy mb-4">Our Mission</h2>
            <p className="text-lg text-gray-600">
              We're building a world where everyone can access the live experiences they love. Our team is passionate about music, sports, theater, and the magic that happens when people come together.
            </p>
          </div>

          {/* Values */}
          <div className="mb-16">
            <h2 className="text-2xl font-semibold text-navy text-center mb-8">Our Values</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {values.map((value, index) => (
                <div key={index} className="bg-white p-6 rounded-xl shadow-md text-center">
                  <h3 className="font-semibold text-navy mb-2">{value.title}</h3>
                  <p className="text-sm text-gray-600">{value.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Benefits */}
          <div className="mb-16">
            <h2 className="text-2xl font-semibold text-navy text-center mb-8">Benefits & Perks</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {benefits.map((benefit, index) => (
                <div key={index} className="bg-white p-6 rounded-xl shadow-md flex items-start gap-4">
                  <div className="w-12 h-12 bg-gold/10 rounded-full flex items-center justify-center text-gold flex-shrink-0">
                    {benefit.icon}
                  </div>
                  <div>
                    <h3 className="font-semibold text-navy mb-1">{benefit.title}</h3>
                    <p className="text-sm text-gray-600">{benefit.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Open Positions */}
          <div className="mb-16">
            <h2 className="text-2xl font-semibold text-navy text-center mb-8">Open Positions</h2>
            <div className="max-w-3xl mx-auto space-y-4">
              {openings.map((job, index) => (
                <div key={index} className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow">
                  <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                    <div>
                      <h3 className="font-semibold text-navy text-lg">{job.title}</h3>
                      <div className="flex flex-wrap gap-2 mt-2">
                        <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded">{job.department}</span>
                        <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded">{job.location}</span>
                        <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded">{job.type}</span>
                      </div>
                    </div>
                    <button className="btn btn-primary whitespace-nowrap">
                      Apply Now
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* No Match CTA */}
          <div className="max-w-2xl mx-auto">
            <div className="bg-navy rounded-2xl p-8 text-center">
              <h3 className="text-xl font-semibold text-white mb-4">Don't see the right role?</h3>
              <p className="text-gray-300 mb-6">
                We're always looking for talented people. Send us your resume and we'll keep you in mind.
              </p>
              <a href="mailto:careers@bestix.ai" className="btn btn-primary">
                Get in Touch
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
